import { ObjectHelpers } from "../../helpers/object-helpers";

export class AiStrategyTradeModel {
    public id= '';
    public symbol= '';
    public isLong = false;
    public entryTime: Date | null = null;
    public entryPrice: number | null = null;
    public exitTime: Date | null = null;
    public exitPrice: number | null = null;
    public exitReason= '';
    public maxProfit: number | null = null;
    public maxProfitTime: Date | null = null;
    public strategyName= '';

    constructor (data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }

    static makeList(dataArray: any[]): AiStrategyTradeModel[] {
        if (!dataArray?.length) return [];
        return dataArray.map(data => new AiStrategyTradeModel(data));
    }
}
